import { ReactComponent as EditIcon } from '../../../../assets/icons/edit-dark.svg';
import { ReactComponent as DuplicateIcon } from '../../../../assets/icons/content_copy.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/icons/delete-outlined.svg';
import { ABSENCE_FIELD_NAMES } from '../../../../constants/absence';

export const getMenuItems = (
  labels,
  data,
  onEdit,
  onDelete,
  onDuplicate,
  onEditTemplate,
  hasDuplicate = false
) => {
  return [
    {
      type: 'edit',
      label: labels.edit,
      shouldItemRender: () => true,
      action: () => onEdit(data),
      icon: EditIcon,
    },
    {
      type: 'editTemplate',
      label: labels.editTemplate,
      shouldItemRender: () => data[ABSENCE_FIELD_NAMES.HAS_TEMPLATE],
      action: () => onEditTemplate(data),
      icon: EditIcon,
    },
    {
      type: 'duplicate',
      label: labels.duplicate,
      shouldItemRender: () => hasDuplicate,
      action: () => onDuplicate(data),
      icon: DuplicateIcon,
    },
    {
      type: 'delete',
      label: labels.delete,
      shouldItemRender: () => true,
      action: () => onDelete(data),
      icon: DeleteIcon,
    },
  ];
};

export const getTotalHolidaysCount = holidays =>
  holidays.reduce((acc, holiday) => {
    return acc + holiday.dates.length;
  }, 0);
